import io from 'socket.io-client';

import {ClientEvents} from '../../../lib/constants/duet';

export default class DashboardSocketClient {
  constructor(data) {
    if (data) {
      this.onReceiveMatch = data.onReceiveMatch;
      this.onReceiveNoMatch = data.onReceiveNoMatch;
      this.onReceiveError = data.onReceiveError;
      this.connect_info = data.connect_info;
    }
  }

  connect() {
    this.socket = io({
      query: this.connect_info,
      transports: ['websocket'],
    });
    this.socket.on(ClientEvents.MATCH, this.onReceiveMatch);
    this.socket.on(ClientEvents.NO_MATCH, this.onReceiveNoMatch);
    this.socket.on(ClientEvents.MATCH_ERROR, this.onReceiveError);
    return this.socket.id;
  }

  emitSetupComplete(settings) {
    this.socket.emit(ClientEvents.SETUP_COMPLETE, settings);
  }

  disconnect() {
    this.socket.disconnect();
  }
}
